/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CreateUpdateVehicleModelReferenceRequest } from "./CreateUpdateVehicleModelReferenceRequest";
import {
    CreateUpdateVehicleModelReferenceRequestFromJSON,
    CreateUpdateVehicleModelReferenceRequestFromJSONTyped,
    CreateUpdateVehicleModelReferenceRequestToJSON,
} from "./CreateUpdateVehicleModelReferenceRequest";

/**
 *
 * @export
 * @interface BulkImportVehicleModelReferencesRequest
 */
export interface BulkImportVehicleModelReferencesRequest {
    /**
     *
     * @type {Array<CreateUpdateVehicleModelReferenceRequest>}
     * @memberof BulkImportVehicleModelReferencesRequest
     */
    entries?: Array<CreateUpdateVehicleModelReferenceRequest>;
}

/**
 * Check if a given object implements the BulkImportVehicleModelReferencesRequest interface.
 */
export function instanceOfBulkImportVehicleModelReferencesRequest(
    value: object,
): value is BulkImportVehicleModelReferencesRequest {
    return true;
}

export function BulkImportVehicleModelReferencesRequestFromJSON(
    json: any,
): BulkImportVehicleModelReferencesRequest {
    return BulkImportVehicleModelReferencesRequestFromJSONTyped(json, false);
}

export function BulkImportVehicleModelReferencesRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BulkImportVehicleModelReferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        entries:
            json["entries"] == null
                ? undefined
                : (json["entries"] as Array<any>).map(
                      CreateUpdateVehicleModelReferenceRequestFromJSON,
                  ),
    };
}

export function BulkImportVehicleModelReferencesRequestToJSON(
    value?: BulkImportVehicleModelReferencesRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        entries:
            value["entries"] == null
                ? undefined
                : (value["entries"] as Array<any>).map(
                      CreateUpdateVehicleModelReferenceRequestToJSON,
                  ),
    };
}
